export enum TestPlanScreen {
    Instrument,
    KeyedInProperty
}